module.exports = __webpack_public_path__ + "img/404.9e89eff.png";